<script setup lang="ts">
const { page } = useContent()
defineProps<{ id: string }>()
const isAPISidebar = page.value?.sidebar == 'API'
</script>

<template>
  <h3 :id="id" :class="[{'sphinx-function': isAPISidebar},{'font-semibold': !isAPISidebar}]">
    <NuxtLink :href="`#${id}`">
      <slot />
    </NuxtLink>
  </h3>
</template>

<style lang="postcss" scoped>
h3 {
  @apply text-gray-900 mt-8 mb-4 scroll-mt-[calc(var(--header-height)+4.5rem)] text-xl leading-snug tracking-tight sm:scroll-mt-[calc(var(--header-height)+2rem)];
}

h3 + * {
  @apply mt-0;
}

h3 > a {
  @apply relative;

  &:before {
    @apply absolute -bottom-[2px] left-[2px] h-[1px] w-[calc(100%-4px)] content-[''];
  }

  &:hover {
    &:before {
      @apply border-gray-900 border-b border-dashed;
    }

    &:after {
      @apply absolute -right-5 h-3 w-3;
      content: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' stroke='%23000' viewBox='0 0 24 24'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M13.828 10.172a4 4 0 0 0-5.656 0l-4 4a4 4 0 1 0 5.656 5.656l1.102-1.101m-.758-4.899a4 4 0 0 0 5.656 0l4-4a4 4 0 0 0-5.656-5.656l-1.1 1.1'/%3E%3C/svg%3E");
    }
  }
}
</style>
